import { isWorkflowTriggerFlowNodeId } from './workflow-flow-node-ids';
import type { WorkflowEditorSelection } from './workflow-toolbar-action.types';
import type { WorkflowGraphApiData } from './workflow-graph.types';

export type {
  WorkflowEditorSelection,
  WorkflowToolbarState,
} from './workflow-toolbar-action.types';

export { EMPTY_WORKFLOW_EDITOR_SELECTION } from './workflow-toolbar-action.types';

export function selectionHasWorkflowNode(
  selection: WorkflowEditorSelection
): boolean {
  return selection.selectedNodeIds.some(
    (nodeId) => !isWorkflowTriggerFlowNodeId(nodeId)
  );
}

export function resolveConnectFromNodeId(
  selection: WorkflowEditorSelection
): string | undefined {
  return selection.selectedNodeIds.find(
    (nodeId) => !isWorkflowTriggerFlowNodeId(nodeId)
  );
}

/**
 * Returns true when the graph contains at least one trigger binding, meaning a
 * trigger is already configured for this workflow.
 */
export function graphHasTrigger(graph: WorkflowGraphApiData | null): boolean {
  if (graph === null) {
    return false;
  }
  return graph.triggerBindings.length > 0;
}

/**
 * All currently selected non-trigger nodes. When two or more are selected,
 * "Add node" fans them all into the new node (one incoming edge each), so a
 * downstream summary step can read every selected step's output.
 */
export function resolveConnectFromNodeIds(
  selection: WorkflowEditorSelection
): readonly string[] {
  return selection.selectedNodeIds.filter(
    (nodeId) => !isWorkflowTriggerFlowNodeId(nodeId)
  );
}
